import React, { useEffect, useState } from 'react'
import { Button } from "@material-ui/core";


import LinearProgress from '@material-ui/core/LinearProgress';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import VismaService from "../../services/visma";
import ProjectService from "../../services/projects";
import ClientsService from "../../services/clients";

export default function SyncProjects(props) {
    let [projects, setProjects] = useState([]);
    let [vismaProjects, setVismaProjects] = useState([]);
    let [notInVismaProject, setNotInVismaProject] = useState([]);
    let [customers, setCustomers] = useState([]);
    let [clients, setClients] = useState([]);
    let [loading,setLoading] = useState(true);


    useEffect(() => {
        getVismaProjects();
        getCustomers();
        getClients();
    }, [])


    let getVismaProjects = () => {
        VismaService.getProjects()
            .then(
                result => {
                    setVismaProjects(result.Data);
                    setTimeout(()=>{
                        getProjects();
                        setLoading(false);
                    },2000)
                },
                error => { })
    }

    let getProjects = () => {
        ProjectService.get()
            .then(
                result => { setProjects(result) },
                error => { })
    }

    let getCustomers = () => {
        VismaService.getCustomers()
            .then(
                result => {
                    setCustomers(result.Data);
                },
                error => { })
    }

    let getClients = () => {
        ClientsService.get()
            .then(
                result => { setClients(result) },
                error => { })
    }

    //compare
    useEffect(() => {
        if (projects.length > 0) {
          
            //find projects from visma not in app
            let tempVismaProjects = Object.assign([], vismaProjects);
            tempVismaProjects.forEach(vismaProject => {
                let found = projects.find(project => { return project.projectnumber.trim() === vismaProject.Number.trim() });
                if (found) {
                    vismaProject.Status = 1;
                } else {
                    vismaProject.Status = 0;
                }
            })
            //find projects from app not in visma
            let notInVisma = [];
            projects.forEach(project => {
                let found = tempVismaProjects.find(tmpProject => { return project.projectnumber.trim() === tmpProject.Number.trim() });
                if (!found) {
                    project.Status = 0;
                    notInVisma.push(project);
                }
            })
            setNotInVismaProject(notInVisma);
            setVismaProjects(tempVismaProjects);
        }
    }, [projects])

    let importProjects = async () => {
        setLoading(true);
        let tempVismaProjects = Object.assign([], vismaProjects);
        for(let v = 0; v < tempVismaProjects.length;v++){
            if (tempVismaProjects[v].Status === 0) {
                let clientID = '';
                //search client
                if (tempVismaProjects[v].CustomerId) {
                    let foundCustomer = customers.find((customer) => { return customer.Id === tempVismaProjects[v].CustomerId });
                    if (foundCustomer) {
                        let foundClient = clients.find((client) => { return client.clientnumber === foundCustomer.CustomerNumber });
                        if (foundClient) {
                            clientID = foundClient._id;
                        }
                    }
                }
    
                let newProject = {};
                newProject.active = true;
                if (clientID.length > 0) {
                    newProject.client = clientID;
                }
                newProject.name = tempVismaProjects[v].Name;
                newProject.projectnumber = tempVismaProjects[v].Number;
                newProject.description = tempVismaProjects[v].Notes;

                let result = await ProjectService.save(newProject);
                if(result){
                    tempVismaProjects[v].Status = 2;
                }
            }
        }
        setVismaProjects(tempVismaProjects);
        setLoading(false);
    }

    let exportProjects = async () => {
        setLoading(true);
        let tempNotInVismaProjects = Object.assign([], notInVismaProject);
        for(let v = 0;v < tempNotInVismaProjects.length;v++){
            let result = await VismaService.createProjectInVisma(tempNotInVismaProjects[v]);
            if(result){
                tempNotInVismaProjects[v].Status = 2;
            }
        }
        setNotInVismaProject(tempNotInVismaProjects);
        setLoading(false);
    }

    let getStatus = (status) => {
        switch (status) {
            case 0:
                return <span style={{ color: 'red' }}>ONTBREEKT</span>;
            case 1:
                return <span style={{ color: 'black' }}>OK</span>;
            case 2:
                return <span style={{ color: 'green' }}>BIJGEWERKT</span>;
            case 3:
                return <span style={{ color: 'red' }}>FOUT</span>;
            default:
                return <span style={{ color: 'orange' }}>ONBEKEND</span>;
        }
    }

    return (
        <Paper  >
             {loading && <LinearProgress color="secondary" />} 
            <h3 className="padding">Projecten uit de Werkbon App die niet in VISMA staan</h3>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Nummer</TableCell>
                        <TableCell>Naam</TableCell>
                        <TableCell>Beschrijving</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notInVismaProject.map(row => (
                        <TableRow key={row._id}>
                            <TableCell >{getStatus(row.Status)} </TableCell>
                            <TableCell >{row.projectnumber} </TableCell>
                            <TableCell >{row.name}</TableCell>
                            <TableCell >{row.description}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button variant="contained" color="primary" onClick={() => { exportProjects() }} style={{ width: '100%' }} disabled={loading}>Exporteer</Button>
       

            <h3 className="padding">Projecten uit VISMA</h3>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Nummer</TableCell>
                        <TableCell>Naam</TableCell>
                        <TableCell>Beschrijving</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {vismaProjects.map(row => (
                        <TableRow key={row.Id}>
                            <TableCell >{getStatus(row.Status)} </TableCell>
                            <TableCell >{row.Number} </TableCell>
                            <TableCell >{row.Name}</TableCell>
                            <TableCell >{row.Notes}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button variant="contained" color="primary" onClick={() => { importProjects() }} style={{ width: '100%' }} disabled={loading}>Importeer</Button>

        </Paper>
    )
}
